/**
 * @desc 补单
 */

import fetch from '@/utils/request'
import config from '@/config'

export interface QueryParams {}

export function request(data: defs.queryOrderDetail): Promise<BaseResponse<defs.ResultBean>> {
  return fetch({
    url: config.API_HOST + '/statistics/queryOrderDetail',
    params: data,
    method: 'GET',
    credentials: 'include',
    timeout: 20 * 1000,
  })
}
